var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingKudzuplus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4076FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.9375C7.42857 9.23004 8.62857 8.2396 10 9.9375C10.4286 10.645 11.6286 11.6354 13 9.9375",
    stroke: "#262B3A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingKudzuplus);
export default __webpack_public_path__ + "static/media/Pending_kudzuplus.925c7ca0e1f28b277e0144b030d3ee4e.svg";
export { ForwardRef as ReactComponent };